import { Table3 } from '@economic/taco';
import { t, Trans } from '@lingui/macro';
import React from 'react';
import { ProductCollectionListViewModel, ProductCollectionModel } from '~/types/internal-api';
import EmptyStateInitializer from '~/app/shared/table3tools/components/EmptyStateInitializer';
import { ProductCollectionTable3DataContext } from './context/ProductCollectionTable3DataContext';

interface SelectProductCollectionTableProps {
    onSelected?: (row: ProductCollectionModel) => void;
}

export function SelectProductCollectionTable(props: SelectProductCollectionTableProps) {
    const { onSelected } = props;

    return (
        <ProductCollectionTable3DataContext.Consumer>
            {context => (
                <div className="[&>table]:h-[65vh]" tabIndex={0}>
                    <h1>
                        <Trans>Product collections</Trans>
                    </h1>

                    <Table3<ProductCollectionListViewModel>
                        id="select-product-collection-table"
                        data={context.data}
                        ref={context.tableRef}
                        length={context.length}
                        loadAll={context.loadAll}
                        loadPage={context.loadPage}
                        pageSize={context.pageSize}
                        enableSorting
                        enableColumnResizing
                        enableSearch
                        enableSaveSettings
                        emptyState={() => <EmptyStateInitializer hasInitialized={context.hasInitialized} />}
                        onRowClick={onSelected}
                        enableRowClick>
                        <Table3.Column<ProductCollectionListViewModel> id="id" header={t`No.`} />
                        <Table3.Column<ProductCollectionListViewModel> id="name" header={t`Collection name`} />
                        <Table3.Column<ProductCollectionListViewModel>
                            id="totalAmount"
                            header={t`Total price`}
                            dataType="amount"
                        />
                    </Table3>
                </div>
            )}
        </ProductCollectionTable3DataContext.Consumer>
    );
}
